import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import type {RootState} from '../store';
import api from '../utils/api';
export interface StorageSnapshot {
  used: number; assigned: number; available: number; reserved: number; percentage: number;
  formattedUsed: string; formattedAssigned: string; formattedAvailable: string;
  breakdown: Record<'drive' | 'mail' | 'otherApps', {used: number; count: number}>;
  tenant?: {quota: number; used: number; available: number; reserved: number};
  footprint?: {logicalBytes: number; referencedObjectBytes: number; activeFileRecords: number; referencedObjects: number};
}
export default function useStorageSnapshot() {
  const identity = useSelector((state: RootState) => state.auth.user?.id);
  const transfers = useSelector((state: RootState) => state.upload.uploads.map(row => `${row.id}:${row.status}`).join('|'));
  const [snapshot, setSnapshot] = useState<StorageSnapshot | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [retry, setRetry] = useState(0);
  useEffect(() => {setSnapshot(null);}, [identity]);
  useEffect(() => {
    const controller = new AbortController();
    const fetch = async () => {
      try {
        const response = await api.get('/storage/quota/me', {signal: controller.signal});
        if (!controller.signal.aborted) {setSnapshot(response.data); setError(null);}
      } catch {if (!controller.signal.aborted) setError('Unable to load storage information');}
    };
    const timer = setTimeout(() => void fetch(), 250);
    const interval = setInterval(() => void fetch(), 60000);
    return () => {clearTimeout(timer); clearInterval(interval); controller.abort();};
  }, [identity, transfers, retry]);
  return {snapshot, error, refresh: () => setRetry(value => value + 1)};
}
